import hover from '../../secondary-button/light-gray/background/hover';

export default hover;
